import { mapActions } from 'vuex'
import router from '@/router'
import { removeToken } from './auth'

// request result handle
const handleReslt = res => {
  if (res.code === 200) { // success
    return { status: true, result: res.data || res }
  } else if (res.code === 401) { // token 过期,或者用户未登录token expired & redirect to login page
    removeToken()
    router.push('/user/login')
  } else { // error msg
    return { status: false, errorCode: res.code, errorMsg: res.msg }
  }
}

const mapFunction = (apis, func) => {
  const outputFucs = {}
  for (const item of Object.keys(apis)) {
    outputFucs[item + 'Action'] = params => {
      return apis[item](params)
        .then(res => {
          if (func) {
            return func()
          } else {
            return handleReslt(res)
          }
        })
        .catch(() => {
          return { status: false, errorMsg: '服务器错误！' }
        })
    }
  }
  return outputFucs
}

const mapRequestActions = (
  apis,
  namespace = '',
  actionArray = [],
  resultHandler
) => {
  return Object.assign(
    {},
    mapFunction(apis, resultHandler),
    mapActions(namespace, actionArray)
  )
}

export { mapRequestActions, handleReslt }
